<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'

defineProps<{
  modelValue: string
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()

const { tabs } = usePusatBantuanData()

const size = ref<'sm' | 'md'>('md')

onMounted(() => {
  const { width } = useWindowSize()
  watchEffect(() => {
    size.value = width.value < 640 ? 'sm' : 'md'
  })
})
</script>

<template>
  <BaseToggleGroup
    :model-value="modelValue"
    :options="tabs"
    :size="size"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
